/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InlineResponse20010
 */
export interface InlineResponse20010 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20010
     */
    paymentMethodId: string;
}

export function InlineResponse20010FromJSON(json: any): InlineResponse20010 {
    return InlineResponse20010FromJSONTyped(json, false);
}

export function InlineResponse20010FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20010 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentMethodId': json['paymentMethodId'],
    };
}

export function InlineResponse20010ToJSON(value?: InlineResponse20010 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentMethodId': value.paymentMethodId,
    };
}


